/* 10% sign-up pop-up. Rules (20 Oct): shows after 12 s or half a page of scroll, whichever comes first;
   once per browser session; closing hides it for 14 days; joining hides it for good; never for signed-in customers. ?su=1 forces it open for checking.
   After a close, a small "10% off" tab (#su-tab) waits on every page the pop-up can show on; tapping it reopens the pop-up.
   The 14-day close only stops the pop-up opening by itself; the tab's own x hides the tab for good (ll-su-tab = gone). */
(function () {
  var KEY = 'll-su', DAY = 864e5;
  function get(s, k) { try { return s.getItem(k); } catch (e) { return null; } }
  function set(s, k, v) { try { s.setItem(k, v); } catch (e) {} }

  var su = document.getElementById('su');
  if (!su) return;
  var state = su.dataset.state, force = /[?&]su=1/.test(location.search), last = null;
  var tab = document.getElementById('su-tab');
  function showTab(on) {
    if (!tab) return;
    if (on && (get(localStorage, 'll-su-tab') === 'gone' || get(localStorage, KEY) === 'joined')) on = false;
    if (on) { tab.hidden = false; requestAnimationFrame(function () { requestAnimationFrame(function () { tab.classList.add('on'); }); }); }
    else { tab.classList.remove('on'); tab.hidden = true; }
  }
  if (tab) tab.addEventListener('click', function (e) {
    if (e.target.closest('[data-su-tabx]')) { set(localStorage, 'll-su-tab', 'gone'); showTab(false); }
    else if (e.target.closest('[data-su-open]')) open();
  });

  function open() {
    if (!su.hidden) return;
    // the 18+ gate (snippets/ll-age.liquid) goes first; the offer waits for its Yes
    if (document.documentElement.classList.contains('ag-on')) return document.addEventListener('ll:age-ok', open, { once: true });
    last = document.activeElement;
    showTab(false);
    su.hidden = false;
    set(sessionStorage, KEY, 'shown');
    requestAnimationFrame(function () { requestAnimationFrame(function () { su.classList.add('open'); }); });
    var f = su.querySelector('input:not([type=hidden]),.su-code button');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 500);
  }
  function close() {
    if (su.hidden) return;
    if (state !== 'done') set(localStorage, KEY, 'closed:' + Date.now());
    if (last === tab || (last && tab && tab.contains(last))) last = null;
    setTimeout(function () { showTab(state !== 'done'); }, 340);
    su.classList.add('closing');
    setTimeout(function () { su.hidden = true; su.classList.remove('open', 'closing'); if (last) last.focus({ preventScroll: true }); }, 320);
  }

  su.addEventListener('click', function (e) {
    if (e.target.closest('[data-su-close]')) close();
    var c = e.target.closest('[data-su-copy]');
    if (c) { if (navigator.clipboard) navigator.clipboard.writeText(c.dataset.suCopy); c.textContent = 'Copied'; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  su.querySelector('form') && su.querySelector('form').addEventListener('submit', function () { set(localStorage, KEY, 'joined'); });
  su.closest('form') && su.closest('form').addEventListener('submit', function () { set(localStorage, KEY, 'joined'); });

  // Shopify reloads the page after the form posts: show the code (or the error) straight away.
  if (state === 'done') { set(localStorage, KEY, 'joined'); return open(); }
  if (state === 'error') { set(localStorage, KEY, ''); return open(); }
  if (force) return open();

  var saved = get(localStorage, KEY) || '';
  if (saved === 'joined') return;
  if (saved.indexOf('closed:') === 0) showTab(true);
  if (saved.indexOf('closed:') === 0 && Date.now() - +saved.slice(7) < 14 * DAY) return;
  if (get(sessionStorage, KEY)) return;

  var t = setTimeout(go, 12000);
  function onScroll() {
    var h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0 && scrollY / h > 0.5) go();
  }
  function go() { clearTimeout(t); removeEventListener('scroll', onScroll); open(); }
  addEventListener('scroll', onScroll, { passive: true });
})();
